const state = {
  phoneToTrunk: {}, // Хранение связей phone -> trunk
};

// Нормализация номера телефона
function normalizePhone(phone) {
  return phone.replace(/[^0-9]/g, ""); // Убираем всё, кроме цифр
}

const mutations = {
  ADD_PHONE_TRUNK(state, { phone, trunk }) {
    state.phoneToTrunk[phone] = trunk; // Используем уже нормализованный телефон как ключ
  },
};

const actions = {
  addPhoneTrunk({ commit }, { phone, trunk }) {
    const normalizedPhone = normalizePhone(phone); // Приводим телефон к нормальному формату
    console.log(`Добавляем связь phone -> trunk: ${normalizedPhone} -> ${trunk}`); // Логируем нормализованный номер
    // Передаём нормализованный телефон в мутацию
    commit("ADD_PHONE_TRUNK", { phone: normalizedPhone, trunk });
  },
};

const getters = {
  getTrunkByPhone: (state) => (phone) => {
    const normalizedPhone = normalizePhone(phone); // Нормализуем номер перед поиском
    return state.phoneToTrunk[normalizedPhone] || null; // Возвращаем trunk или null
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
